<template>
  <div class="container m-tb-30">
    <div class="row row-images">
      <div class="col xs-4">
        <img @click="showInfographic('practices')" src="@/assets/img/home-lead.png" alt="">
      </div>
      <div class="col xs-4">
        <img @click="showInfographic('components')" src="@/assets/img/home-component.png" alt="">
      </div>
      <div class="col xs-4">
        <img @click="showInfographic('strategies')" src="@/assets/img/home-strategic.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import LFModal from '@/lib/lfmodal.js';

export default {
  data() {
    return {
      loading: true,
      infographics: {},
    }
  },
  methods: {
    load(){
      this.loading = true;
      this.$api.get('/v1/infographics')
        .then(({body}) => {
          this.infographics = body.rows[0];
        });
    },

    showInfographic(name){
      const img = `<img src="${this.infographics[name]}" />`;
      this.$store.commit('modal/setContent', img);
      LFModal.show({className: 'modal-fullwidth'});
    }
  },

  created(){
    this.load();
  }

}
</script>

<style lang="scss" scoped>
@import '@/sass/_vars';

.row-images
{
  @media (max-width:$screen-xs - 1)
  {
    text-align: center;

    IMG
    {
      width: 300px;
    }
  }
}
</style>